export default {
  GET_STORAGE_MATERIAL: state => state.storageMaterial,
  GET_STORAGE_INSTRUMENT: state => state.storageInstrument,
}
